// ???????? "????????" ????
const MIN_PRICE = 120;
const MAX_PRICE = 800;

// ?????? ?????? ?? ???????? (????????? ??? ????????)
const RATE_PER_PAGE = 1.0;        // � pages * 1.0..1.2 ??? ?????

// ?????? ??????
const NEW_RELEASE_BOOST = 1.2;    // ??????? (??? 0) ??? ????????? ????
const AGE_DECAY = 0.95;           // ~ -5%/??? (????? ??????? ????)
const AGE_FLOOR_FACTOR = 0.30;    // ?? ????? 30% ??? "?????" (????. -70%)
const YEAR_MIN = 2000;            // ????????? ???? 2000+
const BASE_PRICE_UPLIFT = 1.15;   // +15% ?? ???????????? ??????? ????

function ageFactor(age) {
  if (age <= 0) return NEW_RELEASE_BOOST;  // ???????? ???
  if (age === 1) return 1.0;               // ??????? = 100%
  return Math.max(AGE_FLOOR_FACTOR, Math.pow(AGE_DECAY, age - 1));
}

/** ????? "????" ??????? (base) ? "???? ??????" (borrow = base * 1.15) */
export function priceFromPagesYear(pages, year, nowYear = new Date().getFullYear()) {
  const p = Math.max(40, Math.min(1200, Number(pages) || 0));
  const y = Math.max(YEAR_MIN, Number(year) || nowYear);
  const age = Math.max(0, nowYear - y);

  const raw = RATE_PER_PAGE * p * ageFactor(age);
  const upliftedRaw = raw * BASE_PRICE_UPLIFT;
  const base = Math.round(Math.max(MIN_PRICE, Math.min(MAX_PRICE, upliftedRaw)));
  const borrow = Math.round(base * 1.15);

  return { base, borrow, age };
}
